<div
  class="l-pa-5"
  [ngClass]="{
    'app-loading-overlay': overlay,
    'app-loading-overlay-in-popup': overlayInPopup
  }">
  <cds-progress class="col-lg-6" mode="indeterminate" type="ring" text="loading" [diameter]="60">Loading</cds-progress>
</div>
